import { createAsyncThunk } from "@reduxjs/toolkit";

import { getHeaderNavigationLinks, getFooterNavigationLinks } from "@/models";
import { AppState } from "@/redux/store/store";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";

export const fetchHeaderNavigationLinks = createAsyncThunk(
  "navigationLinks/fetchHeaderNavigationLinks",
  async (params: Partial<{ config: any }>, { getState, rejectWithValue }) => {
    try {
      const { config } = params;
      const { adapter } = getState() as AppState;
      const { baseUrl } = adapter.adapter;
      const { token } = fetchAuthToken(getState());

      const response = await getHeaderNavigationLinks(
        token,
        baseUrl,
        {
          filters: {
            search: "header"
          },
          per_page: 999
        },
        config
      );

      response.map((l) => !l?.children && (l.children = []));

      const links = response.filter((l) => l?.parentId === null);
      const childrenLinks = response.filter((l) => l?.parentId !== null);
      const grandChildrenLinks = childrenLinks;

      /**
       * Construct nested json from data.
       * Find all children that belongs to the current
       * parent and add it to the 'children' key of the parent.
       */
      links.map((parent) => {
        const children = childrenLinks.filter(
          (l) => l.parentId === parseInt(parent.id, 10)
        );

        children.map((child) => {
          return grandChildrenLinks.map((l, index) => {
            return child.id === l.id && grandChildrenLinks.splice(index, 1);
          });
        });

        return (parent.children = children);
      });

      links.map((parent) => {
        if (!parent.children.length) {
          return false;
        }

        return parent.children.map((child) => {
          const grandChildren = childrenLinks.filter(
            (l) => l.parentId === parseInt(child.id, 10)
          );

          grandChildren.map((child) => {
            return grandChildrenLinks.map((l, index) => {
              return child.id === l.id && grandChildrenLinks.splice(index, 1);
            });
          });

          return (child.children = grandChildren);
        });
      });

      return links;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchFooterNavigation = createAsyncThunk(
  "navigationLinks/fetchFooterNavigation",
  async (params: Partial<{ config: any }>, { getState, rejectWithValue }) => {
    try {
      const { config } = params;
      const { adapter } = getState() as AppState;
      const { baseUrl } = adapter.adapter;
      const { token } = fetchAuthToken(getState());

      const response = await getFooterNavigationLinks(
        token,
        baseUrl,
        {
          filters: { search: "footer" }
        },
        config
      );

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
